import { render, staticRenderFns } from "./alertModalSecurity.vue?vue&type=template&id=6248e829&scoped=true&name=alertModalSecurity&"
import script from "./alertModalSecurity.vue?vue&type=script&lang=js&"
export * from "./alertModalSecurity.vue?vue&type=script&lang=js&"
import style0 from "./alertModalSecurity.vue?vue&type=style&index=0&id=6248e829&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6248e829",
  null
  
)

export default component.exports